import { render, staticRenderFns } from "./WebSetup.vue?vue&type=template&id=a150f688&scoped=true"
import script from "./WebSetup.vue?vue&type=script&lang=js"
export * from "./WebSetup.vue?vue&type=script&lang=js"
import style0 from "./WebSetup.vue?vue&type=style&index=0&id=a150f688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a150f688",
  null
  
)

export default component.exports